//Comentario necesario para codificación en UTF-8, ver Inc6743
(function() {
	var App = angular.module('pphhApp');

	App.service("versionCopyActionController", ["$mdDialog", VersionCopyActionController]);
	App.service("dmaVersionCopyActionController", ["$mdDialog", DmaVersionCopyActionController]);
	App.controller("versionCopyDialogController", ["$scope",  "$mdDialog", 
		"$window", "CRUDService", "pphhEnv","params", VersionCopyDialogController]);

	function VersionCopyActionController($mdDialog) {
		this.performAction = performAction;


		function performAction(scope) {
			$mdDialog.show({
				clickOutsideToClose: false,
				escapeToClose: false,
				parent: angular.element(document.body), 
				controller: "versionCopyDialogController",
				templateUrl: "/pphhNav/version-copy-init",
				locals:{params:{wm: scope.waterModule.key}}
			});
		}
	}
	
	
	function DmaVersionCopyActionController($mdDialog) {
		this.performAction = performAction;


		function performAction(scope) {
			$mdDialog.show({
				clickOutsideToClose: false,
				escapeToClose: false,
				parent: angular.element(document.body), 
				controller: "versionCopyDialogController",
				templateUrl: "/pphhNav/version-copy-init",
				locals:{params:{
					wm: scope.waterModule.key,
					type:"pom"
				}}
			});
		}
	}	

	function VersionCopyDialogController($scope, $mdDialog, $window, crudService, pphhEnv,params) {

		$scope.init = init;
		$scope.closeDialog = closeDialog;
		$scope.copy = copy;
		
		$scope.name ="";
		$scope.description = "";
		function init() {
		}

		function closeDialog() {
			$mdDialog.hide();

		}
		function copy() {
			params.name = $scope.name;
			params.description = $scope.description;
			crudService.versionCopy(params)			
			.then(
				function(response) {
					if (response.data.result) {
						$window.location.href = pphhEnv.global.contextPath + "/pphh-sgpusa-init?wm=" +params.wm
					} else {
						var alert = $mdDialog.alert()
							.clickOutsideToClose(true)
							.title(UIMessages.dialog.confirm.title)
							.htmlContent(response.data.message)
							.ok(UIMessages.dialog.confirm.cerrar)
							;
						$mdDialog.show(alert);
					}
				},
				function(response) {					
					var alert = $mdDialog.alert()
						.clickOutsideToClose(true)
						.title(UIMessages.dialog.confirm.title)
						.htmlContent(UIMessages.versionCopy.error)
						.ok(UIMessages.dialog.confirm.ok)
						;
					$mdDialog.show(alert);					
				}
			);
		}
	}

})();